import { InputBase, InputLabel } from '@mui/material'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { LfCloseIcon, SearchIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'

type Props = {
  id: string
  label?: string
  value?: string
  onChange?: (value: string) => void
  clearable?: boolean
  maxLength?: number
  required?: boolean
  disabled?: boolean
  placeholder?: string
  iconSearch?: boolean
}
export default function InputSearch(props: Props): JSX.Element {
  const {
    id,
    label,
    value,
    disabled,
    maxLength,
    required = false,
    clearable = true,
    iconSearch = true,
    onChange,
    placeholder = ''
  } = props

  const inputClassNames = classNames({
    disabled,
    error: required && value === '',
    clearable,
    launched: value !== ''
  })

  const { t } = useTranslation()

  function handleChange(e: any) {
    const { value } = e.target
    onChange?.(value)
  }

  return (
    <>
      {label && (
        <InputLabel id={`${id}-label`} sx={styles.inputLabel} className={inputClassNames}>
          {label} {required ? <span> *</span> : ''}
        </InputLabel>
      )}
      <InputBase
        id={id}
        sx={(styles.input, styles.inputSearch)}
        className={inputClassNames}
        inputProps={{
          maxLength
        }}
        onChange={handleChange}
        value={value}
        required
        placeholder={placeholder}
        endAdornment={
          <>
            {clearable && value ? (
              <div className="inputCleanIcon">
                <LfCloseIcon onClick={() => onChange && onChange('')} />
              </div>
            ) : null}
            {iconSearch ? (
              <div className="inputSearchIcon">
                <SearchIcon />
              </div>
            ) : null}
            {required && value === '' ? (
              <div className="errorSpan">
                <span>{t('form.validation.required.default')}</span>
              </div>
            ) : null}
          </>
        }
      />
    </>
  )
}
